import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormCommons from './commons';
import LoginPasswordInput from '../input/LoginPasswordInput';

const PasswordError = 'Ingrese su contraseña';
const EqualPasswordError = 'Las contraseñas no coinciden';

const RecoveryForm = ({ onSubmit, userName, loading }) => (
  <Formik
    initialValues={{
      userName,
      password: '',
      confirmPassword: '',
    }}
    onSubmit={async (values) => {
      onSubmit(values);
    }}
    validationSchema={Yup.object({
      password: Yup.string()
        .required(PasswordError)
        .matches(FormCommons.passwordRegex, FormCommons.passwordFormatError),
      confirmPassword: Yup.string()
        .required(PasswordError)
        .equals([Yup.ref('password')], EqualPasswordError)
        .matches(FormCommons.passwordRegex, FormCommons.passwordFormatError),
    })}
  >
    {
      ({ errors }) => (
        <Form className="login-modal__form-recovery">
          <LoginPasswordInput className={`input-text ${errors.password ? 'has-error' : ''}`} name="password" placeholder="Contraseña" autoFocus />
          <LoginPasswordInput className={`input-text ${errors.confirmPassword ? 'has-error' : ''}`} name="confirmPassword" placeholder="Repetir contraseña" />
          <button type="submit" className="button-lading" disabled={loading}>
            Continuar
            {' '}
            {
              loading && (<i className="fa fa-spinner fa-pulse fa-2x" />)
            }
          </button>
        </Form>
      )
    }
  </Formik>
);

RecoveryForm.propTypes = {
  userName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default RecoveryForm;
